import { stringify } from 'query-string';

import callWebGate from './callWebGate';

export const GEO = 'geo';
export const GENRE = 'genre';
export const PLAYLIST_CAT = 'moment';

/**
 * @param {String} type
 */
export function createPlaceholder(type, mediaType, wgToken) {
  const url = `adgenerator/v1/fileUpload/${type}?mediaType=${mediaType}`;
  const opts = { method: 'POST' };
  return callWebGate(url, wgToken, opts)
    .then(r => r.json())
    .then(r => ({
      id: r.id,
      action: r.uploadForm.action,
      fields: r.uploadForm.fields,
      uri: r.uri,
    }));
}

/**
 * @param {Object} data
 * @param {String} data.url
 * @param {String} data.formData
 * @param {Function} progressCb
 * @return {Promise}
 */
export function uploadFileToStorage(data, progressCb) {
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();
    req.upload.addEventListener('progress', e => {
      progressCb(100.0 * e.loaded / e.total);
    });
    req.addEventListener('load', resolve);
    req.addEventListener('error', reject);
    req.open('post', data.url);
    req.send(data.formData);
  });
}

/**
 * @param {String} query
 */
export function fetchVoiceovers(query, wgToken) {
  const url = `adgenerator/v1/audiocomponent/voiceover/?name=${query}`;
  return callWebGate(url, wgToken)
    .then(r => {
      if (!r.ok) return r.text().then(e => { throw Error(e); });
      return r.json();
    });
}

/**
 * @param {Object} data
 * @param {String} wgToken
 */
export function postAd(data, wgToken, url) {
  const opts = {
    method: 'POST',
    body: JSON.stringify(data),
  };
  return callWebGate(url, wgToken, opts)
    .then(r => {
      if (!r.ok) return r.text().then(e => { throw Error(e); });
      return r;
    });
}

export function createAd(ad, wgToken) {
  const url = 'adgenerator/v1/ads';
  return postAd(ad, wgToken, url);
}

export function editAd(id, ad, wgToken) {
  const url = `adgenerator/v1/ads/${id}/edit`;
  return postAd(ad, wgToken, url);
}

export function fetchTargeting(field, wgToken, { envOverride } = {}) {
  const url = `adgenerator/v1/targeting/${field}`;
  return callWebGate(url, wgToken, {}, envOverride)
    .then(r => {
      if (!r.ok) return r.json().then(e => Promise.reject(e));
      return r.json();
    });
}

export function fetchStockMusic(wgToken) {
  const url = 'adgenerator/v1/audiocomponent/bgmusic/stockmusic';
  return callWebGate(url, wgToken)
    .then(r => r.ok ? r.json() : r.json().then(Promise.reject));
}

export function searchGeos(query, wgToken) {
  const params = { query };
  const url = `geosearch/v1/search/name?${stringify(params)}`;
  return callWebGate(url, wgToken)
    .then(r => r.ok ? r.json() : r.json().then(Promise.reject));
}



// WEBPACK FOOTER //
// ./src/api/adCreation.js